import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.97 0C4.463 0 0 4.463 0 9.97c0 5.505 4.464 9.969 9.97 9.969s9.969-4.464 9.969-9.97C19.939 4.464 15.476 0 9.969 0m4.571 14.379a.62.62 0 0 1-.854.206c-2.341-1.43-5.288-1.754-8.758-.961a.622.622 0 0 1-.277-1.212c3.798-.868 7.055-.494 9.683 1.112.293.18.386.562.206.855m1.22-2.715a.777.777 0 0 1-1.068.256c-2.68-1.647-6.765-2.124-9.935-1.162a.778.778 0 0 1-.451-1.487c3.62-1.099 8.121-.567 11.199 1.324.365.225.48.704.255 1.069m.105-2.827C12.653 6.929 7.352 6.753 4.284 7.684A.932.932 0 1 1 3.743 5.9c3.522-1.07 9.376-.863 13.075 1.333a.931.931 0 1 1-.951 1.604"
    }, null, -1)
  ])))
}
export default { render: render }